<template>
  <div>
    <div class="music-card">
      <div class="border-bottom">
        <div class="d-flex">
          <div class="music-info">
            <h3>{{ job.title }}</h3>
            <time style="font-size: 11px; font-weight: bold"
              >Deadline:<span class="ml-2">{{ job.deadline }}</span></time
            >
            <br />
            <time style="font-size: 11px; font-weight: bold"
              >Added At:<span class="ml-2">{{ moment(job.added_at.toDate()).format("YYYY-MM-DD") }}</span></time
            >
            <p>{{ job.description }}</p>
          </div>
          <v-avatar v-if="job.profile_image" class="ml-auto" size="42"
            ><img :src="job.profile_image"
          /></v-avatar>
          <v-avatar v-else class="ml-auto" size="42"
            ><img src="/images/default-profile.jpg"
          /></v-avatar>
        </div>
      </div>
      <div class="mt-3">
        <v-btn
          color="primary"
          class="mr-3"
          @click="
            data = { ...job };
            editDialog = true;
          "
          ><i class="fa fa-edit"></i
        ></v-btn>
        <v-btn
          color="red white--text"
          @click="
            id = job.id;
            deleteDialog = true;
          "
          ><i class="fa fa-trash"></i
        ></v-btn>
      </div>
    </div>
    <v-dialog v-model="editDialog" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Edit Job</v-toolbar-title>
        </v-toolbar>
        <v-form ref="ref_edit_job" @submit="lc_edit_job">
          <div class="pa-4">
            <v-text-field
              dense
              flat
              label="Title"
              outlined
              v-model="data.title"
              :rules="[myrules.required]"
            ></v-text-field>
            <v-text-field
              v-model="data.description"
              :rules="[myrules.required]"
              dense
              flat
              label="Description"
              outlined
            ></v-text-field>
            <v-autocomplete
              deletable-chips
              multiple
              small-chips
              solo
              flat
              dense
              outlined
              label="Genre"
              v-model="data.genre"
              :rules="[myrules.arrayRequired]"
              :items="getGenre"
            ></v-autocomplete>
            <v-checkbox
              dense
              color="primary"
              outlined
              label="Paid"
              v-model="data.paid"
            ></v-checkbox>
            <div v-if="data.paid">
              <v-text-field
                dense
                flat
                label="Amount"
                v-model="data.amount"
                :rules="data.paid ? [myrules.required] : []"
                outlined
              ></v-text-field>
            </div>
            <v-text-field
              type="date"
              dense
              flat
              label="Deadline"
              outlined
              v-model="data.deadline"
              :rules="[myrules.required]"
            ></v-text-field>
            <div class="d-flex mt-4">
              <v-btn
                class="mr-3"
                color="red white--text"
                @click="editDialog = false"
                >Cancel</v-btn
              >
              <v-btn color="primary" type="submit">Save</v-btn>
            </div>
          </div>
        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" width="500">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Delete Job</v-toolbar-title>
        </v-toolbar>
        <div class="pa-4">
          Do you really want to delete this Job?
          <div class="d-flex mt-4">
            <v-btn
              class="mr-3"
              color="red white--text"
              @click="deleteDialog = false"
              >Cancel</v-btn
            >
            <v-btn
              color="primary"
              @click="
                (e) => {
                  deleteMusicRoom(id);
                  deleteDialog = false;
                }
              "
              >Delete</v-btn
            >
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "job-card",
  props: ["paid", "job"],
  data() {
    return {
      addDialog: false,
      editDialog: false,
      deleteDialog: false,
      data: {
        title: "",
        description: "",
        genre: [],
        paid: false,
        deadline: "",
      },
    };
  },
  methods: {
    moment,
    async lc_edit_job(e) {
      e.preventDefault();
      let validate = this.$refs.ref_edit_job.validate();

      if (validate) {
        await this.editMusicRoom(this.data);
        this.editDialog = false;
      }
    },
  },
  computed: {
    ...mapGetters(["getGenre"]),
  },
};
</script>

<style scoped>
.music-card {
  margin: 0 15px;
  border-radius: 5px;
  margin-top: 15px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 15px;
}
.success {
  background: chartreuse !important;
  color: #fff;
}
.danger1 {
  background: red !important;
  color: #fff;
}
</style>